// import React, { useContext, useEffect, useRef, useState } from 'react';
// import Application from '../../StateContext/Application';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { apiurl } from '../../../../path'
// import { Back32 } from '../../../../public/LoginImages/importimages';
// import { use } from 'react';

// const TechnicalSanction = () => {
//     const submitLockRef = useRef(false);
//     const operation = useContext(Application)
//     const { sanctionCreation, GetBudgetHeadInfo, getGRNPendingList, GetGramPanchayatCodes, TypesOfWork, GetTechnicalCoordinates, SecureFileFetching } = operation;
//     const [project, setProjectList] = useState([])
//     const [diableChoosebutton, setDisableChoosebutton] = useState(false);
//     const [locationData, setLocationData] = useState(null);
//     const [showerror, setshowerror] = useState("");
//     const [active, setactive] = useState(true);
//     const [saveButtonDisable, setsaveButtonDisable] = useState(false)

//     const [loading, setLoading] = useState(false);
//     const { id } = useParams()
//     const nav = useNavigate();
//     const [HeadInfo, setHeadInfo] = useState([]);
//     const formdataRef = useRef(null);
//     const [data, setData] = useState({
//         HeadName: '',
//         HeadCode: '',
//         HeadCRC: "",
//         sanctionYear: '',
//         rddUid: '',
//         proposalUid: '',
//         District: "",
//         taluka: '',
//         constituency: '',
//         gramPanchayat: '',
//         village: null,
//         workName: '',
//         workType: '',
//         amount: '',
//         sanctionNo: '',
//         file: null,
//         isMultipleGp: '',
//         GRCopy: "",
//         GRDraftCopy: "",
//         Coordinates: "",
//         Remark: "",
//         GPCode: "",
//         DPCode: "",
//         workClass: "",
//     });
//     // const [GPCode, setGPCode] = useState("");
//     // const [DPCode, setDPCode] = useState("");
//     const [getWork, setWork] = useState([])
//     const [getGeometryOfWork, setGeometryOfWork] = useState("")
//     const [WorkId, setWorkId] = useState([])
//     const query = new URLSearchParams(useLocation().search);
//     const page = query.get("returnPage") || 1;
//     const HandleChangeData = (e) => {
//         const { name, value, type, files } = e.target;
//         if (name === "amount") {
//             const number = parseFloat(value);
//             if (number < 0) return;
//         }
//         if (name === "workType" && value === "") {
//             alert("Select Work Type")
//         }
//         if (name === "sanctionNo") {
//             if (value.length === 1 && value === " ") return;

//             const trimmedValue = value.trimStart();

//             setData(prev => ({
//                 ...prev,
//                 sanctionNo: trimmedValue
//             }));
//             return;
//         }
//         setData({
//             ...data,
//             [name]: type === 'file' ? files[0] : value,
//         });
//     };

//     const handleBack = () => {
//         const returnPage = query.get('returnPage');
//         nav(`/AdminDashboard/GRPendingList${returnPage ? `?page=${returnPage}` : ''}`);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // 🔐 HARD LOCK (instant, sync)
//         if (submitLockRef.current) return;
//         submitLockRef.current = true;

//         if (
//             !data.HeadCode || !data.sanctionYear || !data.rddUid ||
//             !data.proposalUid || !data.District || !data.taluka ||
//             !data.constituency || !data.gramPanchayat || !data.workName ||
//             !data.workType || !data.sanctionNo || !data.amount ||
//             !data.isMultipleGp || !data.Coordinates
//         ) {
//             alert("Data is Missing Fill All Data !!!!");
//             submitLockRef.current = false;
//             return;
//         }

//         if (data.sanctionNo.trim() === "") {
//             alert("MHUID Number cannot be empty");
//             submitLockRef.current = false;
//             return;
//         }

//         setLoading(true); // UI lock

//         try {
//             const formData = new FormData();

//             for (let key in data) {
//                 if (key === "GPCode" || key === "DPCode") continue;
//                 formData.append(key, data[key]);
//             }

//             const files = document.getElementById("TechnicalSanctionCopy").files;
//             if (!files || files.length === 0) {
//                 alert("Sanction Copy is Missing !!!");
//                 submitLockRef.current = false;
//                 setLoading(false);
//                 return;
//             }

//             formData.append("TechnicalSanctionCopy", files[0]);

//             if (data.isMultipleGp === "Yes") {
//                 formData.append("DPCode", data.DPCode || "");
//             } else {
//                 formData.append("GPCode", data.GPCode || "");
//             }

//             const result = await sanctionCreation(formData);

//             alert(result);

//             // 🚨 IMPORTANT: disable button BEFORE reload
//             setTimeout(() => {
//                 window.location.reload();
//             }, 300);

//         } catch (err) {
//             console.error(err);
//             alert("Submission failed. Please try again.");
//         } finally {
//             setLoading(false);
//             submitLockRef.current = false; // unlock ONLY after response
//         }
//     };

//     const FetchHeadInfo = async () => {
//         try {
//             let res = await GetBudgetHeadInfo("null", "all");
//             console.log("Data i get from Bakcend :: ", res);
//             setHeadInfo(res);
//         } catch (err) {
//             console.log(err);
//         }
//     }

//     const CheckCoordinateFunction = async (id, savedData) => {
//         try {
//             let res = await GetBudgetHeadInfo(id, "GetSpecificCoordinatefortechnical");
//             if (res.length > 0 && res[0].TechnicalSanctionArea != null) {
//                 console.log("Data i get form backe--------------------- ", res[0]);
//                 // setDisableChoosebutton(true);
//                 setData({ ...savedData, Area: res[0].TechnicalSanctionArea });
//                 setLocationData(res[0]);
//             } else {
//                 // setDisableChoosebutton(false)
//             }
//         } catch (err) {
//             console.error(err);
//         }
//     }

//     useEffect(() => {
//         const savedFormData = sessionStorage.getItem('createTechnicalForm');
//         if (savedFormData) {
//             let savedData = JSON.parse(savedFormData)
//             setData(savedData);
//             CheckCoordinateFunction(savedData.workName, savedData);
//             // sessionStorage.removeItem('createTechnicalForm');
//         }
//         GetParticularGR();
//     }, []);

//     const GetParticularGR = async () => {
//         let res = await getGRNPendingList(id, "technicalsanction");
//         const proj = res[0];
//         console.log("Particular Data i get form backend :: ", res[0]);
//         setProjectList(proj);
//         setData((prev) => ({
//             ...prev,
//             HeadCode: proj.HeadCode || '',
//             HeadName: proj.HeadName || '',
//             HeadCRC: proj.CRC || '',
//             sanctionYear: proj.ProposalYear || '',
//             rddUid: proj.GRID || '',
//             proposalUid: proj.ProposalID || '',
//             District: proj.ZillaParishad || '',
//             taluka: proj.Taluka || '',
//             constituency: proj.Constituency_name || '',
//             gramPanchayat: proj.Gram_panchayat || '',
//             workName: proj.Work_name || '',
//             GRCopy: proj.GRCopy || '',
//             GRDraftCopy: proj.GRDraftCopy || '',
//             Area: proj.Area,
//             amount: proj.ProposalAmount,
//             // GPCode: GPCode,
//             getGeometryOfWork: getGeometryOfWork,
//             workClass: proj.classOfWork,
//             workType: proj.typeOfWork,
//             isMultipleGp: proj.isMultipleGP
//         }));
//     };

//     const resetdata = () => {
//         formdataRef.current.reset();
//         setData({
//             HeadCode: '',
//             sanctionYear: '',
//             rddUid: '',
//             proposalUid: '',
//             District: "",
//             District: "",
//             taluka: '',
//             constituency: '',
//             gramPanchayat: '',
//             village: null,
//             workName: '',
//             workType: '',
//             amount: '',
//             sanctionNo: '',
//             file: null,
//             isMultipleGp: '',
//         })
//     }

//     const getGPCode = async () => {
//         try {
//             let res1 = await GetBudgetHeadInfo('null', "GetTalukas");
//             console.log("res1 :: ", res1);
//             let DistrictEng = res1[0].District;

//             let parsedData = [];

//             if (typeof data.gramPanchayat === "string") {
//                 try {
//                     parsedData = JSON.parse(data.gramPanchayat);
//                 } catch (e) {
//                     console.warn("gramPanchayat not valid JSON:", data.gramPanchayat);
//                 }
//             } else if (Array.isArray(data.gramPanchayat)) {
//                 parsedData = data.gramPanchayat;
//             }

//             let firstElement = parsedData.length > 0 ? parsedData[0] : "";

//             // let GPName = { gramPanchayat: data.gramPanchayat, DistrictEng: DistrictEng };
//             let GPName = { gramPanchayat: firstElement, DistrictEng: DistrictEng };
//             let res = await GetGramPanchayatCodes(GPName, "TechnicalSanction");
//             let gp = res.find(
//                 (item) => item.Village_Panchayat_Name === firstElement
//             );
//             if (gp) {
//                 console.log("Matched GP:", gp);
//                 setData((prev) => ({
//                     ...prev,
//                     GPCode: gp.Village_Panchayat_Code,   // ✅ update inside data directly
//                     DPCode: gp.District_Code
//                 }));
//                 // setDPCode(gp.District_Code)
//                 // setGPCode(gp.Village_Panchayat_Code)
//             } else {
//                 console.warn("No GP found for", data.gramPanchayat);
//             }
//         } catch (err) {
//             console.log(err);
//         }
//     };

//     // useEffect(() => {
//     //     if (GPCode) {
//     //         setData((prev) => ({
//     //             ...prev,
//     //             GPCode: GPCode,
//     //         }));
//     //     }
//     // }, [GPCode]); // whenever GPCode updates, sync it into data

//     useEffect(() => {
//         if (data.gramPanchayat) {
//             getGPCode();
//         }
//     }, [data.gramPanchayat])

//     const navigatetoMap = (e) => {
//         e.preventDefault();
//         if (data.HeadCode && data.sanctionYear && data.rddUid && data.proposalUid && data.District && data.taluka && data.constituency && data.gramPanchayat && data.workName && data.workType && data.sanctionNo && data.isMultipleGp) {
//             let updatedData = { ...data };
//             console.log("data", data);
//             // console.log("dpcode", DPCode);
//             console.log("gpcode", data.GPCode);

//             if (data.isMultipleGp === "Yes") {
//                 if (!data.DPCode) {
//                     alert("DP Code not found !!!");
//                     return;
//                 }
//                 console.log("dp");

//                 updatedData.DPCode = data.DPCode;
//                 updatedData.GPCode = "";
//             }
//             else {
//                 if (!data.GPCode) {
//                     alert("GP Code not found !!!");
//                     return;
//                 }
//                 console.log("gp");

//                 updatedData.GPCode = data.GPCode;
//                 updatedData.DPCode = "";
//             }
//             console.log("updateddata", updatedData);
//             setData(updatedData);
//             console.log("data", data);

//             // Save form data to sessionStorage
//             sessionStorage.setItem('createTechnicalForm', JSON.stringify(updatedData));
//             nav(`/AdminDashboard/MapfunctionForTechnicalSanction`);

//         } else {
//             alert("Fill Above Data !!!!");
//         }
//     };

//     const CancelMapSubmission = () => {
//         const shouldclose = window.confirm("Are you Sure ?");
//         if (shouldclose) {
//             const savedFormData = sessionStorage.getItem('createTechnicalForm');
//             if (savedFormData) {
//                 sessionStorage.removeItem('createTechnicalForm');
//             }
//             alert("Technical Sanction Cancelled !!");
//             nav(`/AdminDashboard/GRPendingList`);
//             window.location.reload();
//         }
//     }

//     const GetTypesOfWork = async () => {
//         console.log(data.HeadName);
//         try {
//             let res = await TypesOfWork(data.HeadName);
//             setWorkId(res);
//             setLoading(true);
//             console.log("Type Of Work :: ", res);
//             console.log("Work Class :: ", data.workClass);

//             if (data.HeadName == "3054-2419(Roads and bridge repair maintenance program)") {
//                 let workNames = res.filter((item) => item.Work_Type === data.workClass);
//                 console.log("Work Names :: ", workNames);
//                 setWork(workNames)
//             }
//             else {
//                 let workNames = res.filter((item) => item.Work_Type === data.workClass);
//                 console.log("Work Names :: ", workNames);
//                 setWork(workNames)
//             }
//             setLoading(false);
//             let GeometryOfWork = res.find((item) => item.Work_name == data.workType);
//             console.log("Geometry of Work :: ", GeometryOfWork);
//             setGeometryOfWork(GeometryOfWork.Geometry_type)
//             setData((prev) => ({
//                 ...prev,
//                 getGeometryOfWork: GeometryOfWork.Geometry_type
//             }))
//         } catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         if (data.HeadName !== "") {
//             GetTypesOfWork();
//         }
//     }, [data.HeadName, data.workType, data.workClass]);

//     // const GetCoordinates = async () => {
//     //     try {
//     //         console.log(data.sanctionNo);
//     //         let res = await GetTechnicalCoordinates(data.sanctionNo);
//     //         console.log("Coordinates :: ", res);
//     //         let parsedCoords = "";
//     //         let gisDataStr = "";
//     //         let Remark = "";
//     //         let GPCode = "";
//     //         let DPCode = "";
//     //         if (Array.isArray(res) && res.length > 0) {
//     //             gisDataStr = res[0].gis_data;   // string
//     //             Remark = res[0].remark || 'NA';
//     //             GPCode = res[0].gpcode || 0;
//     //             // DPCode = res[0].dpcode || 0;
//     //             // try {
//     //             //     let coords = JSON.parse(gisDataStr); // parse the string into an array
//     //             //     if (Array.isArray(coords) && coords.length > 0) {
//     //             //         parsedCoords = `X: ${coords[0].x}, Y: ${coords[0].y}`;
//     //             //     }
//     //             // } catch (err) {
//     //             //     console.error("Error parsing gis_data", err);
//     //             const savedFormData = sessionStorage.getItem("createTechnicalForm");
//     //             if (savedFormData) {
//     //                 const formData = JSON.parse(savedFormData);
//     //                 localStorage.getItem("sanctionNo", formData.sanctionNo);
//     //                 localStorage.getItem("workType", formData.workType);
//     //                 // const sanctionNo = formData.sanctionNo;
//     //                 // const workType = formData.workType;
//     //                 // setData((prev) => ({
//     //                 //     ...prev,
//     //                 //     sanctionNo: sanctionNo,
//     //                 //     workType: workType,

//     //                 // }))
//     //             }
//     //             // console.log(sanctionNo);
//     //             // console.log(workType);
//     //             // }
//     //             setData((prev) => ({
//     //                 ...prev,
//     //                 Coordinates: gisDataStr,
//     //                 Remark: Remark,
//     //                 // GPCode: GPCode || prev.GPCode,
//     //                 // DPCode: DPCode || prev.DPCode,
//     //             }))
//     //         }
//     //     }
//     //     catch (err) {
//     //         console.log(err);
//     //     }
//     // }

//     const GetCoordinates = async () => {
//         try {
//             console.log(data.sanctionNo);

//             let res = await GetTechnicalCoordinates(data.sanctionNo);
//             const { status, message, buttonstatus } = res;
//             console.log("GIs Data from Backend --> ", res);

//             if (status) {
//                 setactive(true);
//                 setshowerror(message);
//                 setsaveButtonDisable(status);
//             }
//             else {
//                 setactive(buttonstatus);
//                 setsaveButtonDisable(status);
//                 setshowerror("");
//                 console.log("Coordinates :: ", res);
//                 let parsedCoords = "";
//                 let gisDataStr = "";
//                 let Remark = "";
//                 let GPCode = "";
//                 let DPCode = "";

//                 if (buttonstatus == false) {
//                     setData((prev) => ({
//                         ...prev,
//                         Coordinates: "",
//                         Remark: ""
//                     }));
//                     setshowerror("");
//                 }
//                 else if (res.message && res.message.length > 0) {
//                     setshowerror("Map is assigned to this MHUID Number");
//                     let GISDATA = res.message[0];
//                     gisDataStr = GISDATA.gis_data;
//                     console.log("GisData Str ---> ", gisDataStr);
//                     Remark = GISDATA.remark || 'NA';
//                     GPCode = GISDATA.gpcode || 0;
//                     // DPCode = res[0].dpcode || 0;
//                     // try {
//                     //     let coords = JSON.parse(gisDataStr); // parse the string into an array
//                     //     if (Array.isArray(coords) && coords.length > 0) {
//                     //         parsedCoords = `X: ${coords[0].x}, Y: ${coords[0].y}`;
//                     //     }
//                     // } catch (err) {
//                     //     console.error("Error parsing gis_data", err);
//                     const savedFormData = sessionStorage.getItem("createTechnicalForm");
//                     if (savedFormData) {
//                         const formData = JSON.parse(savedFormData);
//                         localStorage.getItem("sanctionNo", formData.sanctionNo);
//                         localStorage.getItem("workType", formData.workType);
//                         // const sanctionNo = formData.sanctionNo;
//                         // const workType = formData.workType;
//                         // setData((prev) => ({
//                         //     ...prev,
//                         //     sanctionNo: sanctionNo,
//                         //     workType: workType,

//                         // }))
//                     }
//                     // console.log(sanctionNo);
//                     // console.log(workType);
//                     // }
//                     setData((prev) => ({
//                         ...prev,
//                         Coordinates: gisDataStr,
//                         Remark: Remark,
//                         // GPCode: GPCode || prev.GPCode,
//                         // DPCode: DPCode || prev.DPCode,
//                     }))
//                 }
//             }
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         if (data.sanctionNo) {
//             GetCoordinates();
//         }
//     }, [data.sanctionNo]);

//     const checkingGisDatabasedonProposalId = async () => {
//         try {
//             let res = await GetTechnicalCoordinates(id, "Proposal");
//             const { status, message, result } = res;

//             if (status) {
//                 alert(message);
//                 console.log("Coordinates :: ", res);
//                 let parsedCoords = "";
//                 let gisDataStr = "";
//                 let Remark = "";
//                 let GPCode = "";
//                 let DPCode = "";

//                 let GISDATA = res.result[0];
//                 gisDataStr = GISDATA.gis_data;
//                 console.log("GisData Str ---> ", gisDataStr);
//                 Remark = GISDATA.remark || 'NA';
//                 GPCode = GISDATA.gpcode || 0;
//                 let techncialsanctionno = GISDATA.activity_code || 0;

//                 setData((prev) => ({
//                     ...prev,
//                     Coordinates: gisDataStr,
//                     Remark: Remark,
//                     sanctionNo: techncialsanctionno
//                 }));

//                 setDisableChoosebutton(true);
//                 // setactive(true);
//             }
//         }
//         catch (err) {
//             alert("Internal Server Error ");
//         }
//     }

//     useEffect(() => {
//         if (id) {
//             checkingGisDatabasedonProposalId()
//         }
//     }, [id])

//     const handleFileUpload = (e) => {

//         const file = e.target.files[0];
//         if (!file) return;

//         const allowedTypes = [
//             "application/pdf",
//             "image/jpeg",
//             "image/png",
//         ];

//         if (!allowedTypes.includes(file.type)) {
//             alert("Only PDF, JPG , JPEG, PNG files are allowed");
//             e.target.value = ""; // Reset input
//             return;
//         }
//     };

//     return (
//         <div style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden" }}>

//             {loading && (
//                 <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '0%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                     <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                     <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
//                 </div>
//             )}
//             <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="justify-content-between d-flex align-items-center px-5 py-4" >
//                     <button className='btn btn-danger rounded-4' onClick={handleBack}> <i class="fa fa-arrow-left" aria-hidden="true" /> Back</button>
//                 </div>
//                 <div className="col-12 m-auto my-5 budgetContainer">
//                     <div className="m-auto my-5 budgetElement">

//                         <div className="row px-3 mb-4 mt-3">
//                             <div style={{ display: "flex", alignItems: "center" }}>
//                                 < img src="/MIS-Report-Blue-64.png" alt="TechnicalSanction" style={{ width: "32px", height: "32px" }} className='my-auto me-2' />
//                                 <h3 className='text-left fw-bold mt-2'>Technical Sanction</h3>
//                             </div>
//                             <div className="col-12 mt-4">
//                                 <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>Note : Fields marked with * are mandatory</p>
//                             </div>
//                         </div>
//                         <form onSubmit={handleSubmit} ref={formdataRef} style={{ padding: '10px', width: '40rem' }}>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Head Code</label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.HeadCode} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Sanction Year *</label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.sanctionYear} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>GR UID <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.rddUid} disabled />

//                                     </div>
//                                 </div>
//                             </div>
//                             {/* <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Proposal UID <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.proposalUid} disabled />
//                                     </div>
//                                 </div>
//                             </div> */}
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>District <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.District} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Taluka <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.taluka} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Constituency Name <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.constituency} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Gram Panchayat <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.gramPanchayat} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Work Name <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input className='py-2' value={data.workName} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Class Of Work<span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input name="workClass" id="" value={data.workClass} onChange={HandleChangeData} disabled>
//                                         </input>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Type of Work <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input name="workType" id="" value={data.workType} onChange={HandleChangeData} disabled>
//                                         </input>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Technical Sanctioned Amount <span className='text-danger fw-bold'>*</span></label></div>
//                                     <div className="col-7">
//                                         <input
//                                             name="amount"
//                                             className='w-100 py-2'
//                                             type="number"
//                                             value={data.amount}
//                                             min="0"
//                                             step="0.01"
//                                             onChange={HandleChangeData}
//                                             onKeyDown={(e) => {
//                                                 if (["e", "E", "+", "-", "."].includes(e.key)) {
//                                                 }
//                                             }}
//                                             disabled
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>MHUID Number</label></div>
//                                     <div className="col-7">
//                                         <input name="sanctionNo" placeholder='Enter MHUID Number' className='py-2' value={data.sanctionNo} onChange={HandleChangeData}
//                                             maxLength={16}
//                                         />
//                                         {
//                                             showerror && (
//                                                 <p className='text-danger my-auto fw-bold' style={{ fontSize: "10px" }}>{showerror}</p>
//                                             )
//                                         }

//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5">
//                                         <label>This involves multiple Gram Panchayat?</label>
//                                     </div>
//                                     <div className="col-7" style={{ justifyContent: "space-evenly", display: "flex" }}>
//                                         <div>
//                                             <label><input type="radio" name="isMultipleGp" value="Yes" checked={data.isMultipleGp === "Yes"} /></label>
//                                             <label>Yes</label>
//                                         </div>
//                                         <div>
//                                             <label><input type="radio" name="isMultipleGp" value="No" checked={data.isMultipleGp === "No"} /></label>
//                                             <label>No</label>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5">
//                                         <label>Choose Area <span className='text-danger fw-bold'>*</span></label>
//                                     </div>
//                                     <div className="col-7">
//                                         {/* {
//                                             diableChoosebutton ? (
//                                                 <textarea className="form-control" rows={6} readOnly value={locationData?.TechnicalSanctionArea?.map((coord) => `(${coord[0]} , ${coord[1]})`).join('\n') || ''} />
//                                             ) : (
//                                                 <button className='btn btn-success w-100' onClick={(e) => navigatetoMap(e)}>Choose Area</button>
//                                             }
//                                         ) */}
//                                         <button
//                                             className='btn btn-success w-100'
//                                             onClick={(e) => navigatetoMap(e)}
//                                             disabled={active}>
//                                             Choose Area
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Co-ordinates</label></div>
//                                     <div className="col-7">
//                                         <textarea name="Coordinates" className='py-2' value={data?.Coordinates} onChange={HandleChangeData} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Remark(If Overlapping)</label></div>
//                                     <div className="col-7">
//                                         <input type='text' name="Remark" className='py-2' value={data?.Remark} onChange={HandleChangeData} disabled />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"><label>Technical Sanction Copy <span className="text-danger fw-bold">*</span></label></div>
//                                     <div className="col-7">
//                                         <input type="file" className='py-2' name="TechnicalSanctionCopy" id="TechnicalSanctionCopy" accept=".pdf,.jpg,.jpeg,.png,image/jpeg,image/png,application/pdf" onChange={handleFileUpload} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 ms-auto my-4">
//                                 <div className="row">
//                                     <div className="col-5"></div>
//                                     <div className="col-7">
//                                         <div className="col-12">
//                                             <button
//                                                 type="button"
//                                                 className="px-4 py-1 btn btn-primary"
//                                                 disabled={loading || submitLockRef.current}
//                                                 style={{
//                                                     cursor: loading ? "not-allowed" : "pointer",
//                                                     opacity: loading ? 0.7 : 1
//                                                 }}
//                                                 onClick={handleSubmit}
//                                             >
//                                                 {loading ? "Saving..." : "Save"}
//                                             </button>
//                                             <button type="button" className='px-4 py-1 btn btn-danger mx-4' onClick={() => CancelMapSubmission()} >Cancel</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                         <div style={{ border: "1px solid #ccc", width: "20rem", fontFamily: "Arial" }}>
//                             <div style={{ backgroundColor: "#1f6e9b", color: "white", padding: "8px", fontWeight: "bold", }}>
//                                 Approved Proposal Details
//                             </div>
//                             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                                 <tbody>
//                                     <tr>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>Proposal File Number</td>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>{project.Proposal_fileNumber}</td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>Final Proposal Amount</td>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>{`${project.Proposal_amount}`}</td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>Proposal Copy</td>
//                                         <td style={{ padding: "8px", border: "1px solid #ccc" }}>
//                                             {/* <a href={`${apiurl}/ProposalFile/${project.Proposal_copy}`} target='_blank'>{project.Proposal_copy}</a> */}
//                                             {
//                                                 project.Proposal_copy ? (<p
//                                                     onClick={() => SecureFileFetching(`ProposalFile/${project.Proposal_copy}`)}
//                                                     style={{
//                                                         fontSize: "12px",
//                                                         color: "#0d6efd",
//                                                         textDecoration: "underline",
//                                                         cursor: "pointer",
//                                                         margin: 0,
//                                                     }}
//                                                     title={project.Proposal_copy}
//                                                 >
//                                                     {project.Proposal_copy}
//                                                 </p>) :
//                                                     (<span className='text-danger fw-bold'>No File</span>)
//                                             }

//                                         </td>
//                                         <button style={{ color: "white", border: "none", padding: "6px 12px", cursor: "pointer" }}>
//                                         </button>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TechnicalSanction;

import React, { useContext, useEffect, useRef, useState } from "react";
import Application from "../../StateContext/Application";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { apiurl } from "../../../../path";
import { Back32 } from "../../../../public/LoginImages/importimages";
import { use } from "react";
import validateFile from "../../../../utils/fileUploadHelper";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";

const TechnicalSanction = () => {
  const submitLockRef = useRef(false);
  const operation = useContext(Application);
  const {
    sanctionCreation,
    GetBudgetHeadInfo,
    getGRNPendingList,
    GetGramPanchayatCodes,
    TypesOfWork,
    GetTechnicalCoordinates,
    SecureFileFetching,
  } = operation;
     const { language, toggleLanguage, t } = useLanguage();
  const [project, setProjectList] = useState([]);
  const [diableChoosebutton, setDisableChoosebutton] = useState(false);
  const [locationData, setLocationData] = useState(null);
  const [showerror, setshowerror] = useState("");
  const [active, setactive] = useState(true);
  const [saveButtonDisable, setsaveButtonDisable] = useState(false);
 const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const nav = useNavigate();
  const [HeadInfo, setHeadInfo] = useState([]);
  const formdataRef = useRef(null);
  const [error, setError] = useState("");
  const [GPname, setGPname] = useState([])
  const [data, setData] = useState({
    HeadName: "",
    HeadCode: "",
    HeadCRC: "",
    sanctionYear: "",
    rddUid: "",
    proposalUid: "",
    District: "",
    taluka: "",
    constituency: "",
    gramPanchayat: [],
    village: null,
    workName: "",
    workType: "",
    amount: "",
    sanctionNo: "",
    file: null,
    isMultipleGp: "",
    GRCopy: "",
    GRDraftCopy: "",
    Coordinates: "",
    Remark: "",
    GPCode: "",
    DPCode: "",
    workClass: "",
    JOB_ID: "",
    MHUIDNo: "",
  });

  console.log("Data: ", data);

  // const [GPCode, setGPCode] = useState("");
  // const [DPCode, setDPCode] = useState("");
  const [getWork, setWork] = useState([]);
  const [getGeometryOfWork, setGeometryOfWork] = useState("");
  const [WorkId, setWorkId] = useState([]);
  const query = new URLSearchParams(useLocation().search);
  const page = query.get("returnPage") || 1;
    const [gramPanchayat, setgramPanchayat] = useState([])
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
        alert(validation.message);
        e.currentTarget.value = "";
        return;
    }
  };
   const GetGramPanchayat = async () => {
          try {
              let res = await GetGramPanchayatCodes(GPname, "Proposal");
              console.log(GPname);
              console.log("Data of grampanchayat:: ", res)
              // let GramPanchayat = res.filter((item) => item.Development_Block_Name === GPname);
              console.log("Data of grampanchayat:: ", res);
              setgramPanchayat(res);
          }
          catch (err) {
              console.log(err);
          }
      }
      
          useEffect(() => {
              if (GPname) {
                  GetGramPanchayat();
              }
          }, [GPname]);
             const getEnglishNameOFTaluka = async () => {
                  let res = await GetBudgetHeadInfo("null", "GetTalukas");
                  let talukaNameEnglish = res.filter((item) => item.ULBNameMarathi === data.taluka);
                  console.log("Data of taluka:: ", talukaNameEnglish);
                  if (talukaNameEnglish.length > 0) {
                      setGPname(talukaNameEnglish[0].ULBName);
                  } else {
                      console.warn("No matching Taluka found for Marathi name:", data.Taluka);
                      setGPname("");
                  }
              }
              useEffect(() => {
                  getEnglishNameOFTaluka();
              }, [data.taluka]);

  const HandleChangeData = (e) => {
    const { name, value, type, files } = e.target;
    if (name === "amount") {
      const number = parseFloat(value);
      if (number < 0) return;
    }
    if (name === "workType" && value === "") {
      alert("Select Work Type");
    }
    if (name === "sanctionNo") {
      // block first character as space
      if (value.length === 1 && value === " ") return;

      // remove starting spaces
      const trimmedValue = value.trimStart();

      setData((prev) => ({
        ...prev,
        sanctionNo: trimmedValue,
      }));
      return;
    }
    setData({
      ...data,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleBack = () => {
    const returnPage = query.get("returnPage");
    nav(
      `/AdminDashboard/GRPendingList${returnPage ? `?page=${returnPage}` : ""}`,
    );
  };

  // const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     console.log("Data of this form ", data);

  //     // 🔐 HARD LOCK (instant, sync)
  //     if (submitLockRef.current) return;
  //     submitLockRef.current = true;

  //     if (!data.HeadCode || !data.sanctionYear || !data.rddUid || !data.proposalUid || !data.District || !data.taluka || !data.constituency || !data.gramPanchayat || !data.workName || !data.workType || !data.sanctionNo || !data.amount || !data.isMultipleGp || !data.Coordinates) {
  //         submitLockRef.current = false;
  //         return alert("Data is Missing Fill All Data !!!!");
  //     }

  //     if (!data.sanctionNo || data.sanctionNo.trim() === "") {
  //         submitLockRef.current = false;
  //         return alert("MHUID Number cannot be empty or only spaces");
  //     }

  //     if (/^\s|\s$/.test(data.sanctionNo)) {
  //         submitLockRef.current = false;
  //         return alert("MHUID Number must not contain leading or ending spaces");
  //     }

  //     setLoading(true);

  //     try {
  //         const formData = new FormData();

  //         for (let key in data) {
  //             if (key === "GPCode" || key === "DPCode") continue;
  //             formData.append(key, data[key]);
  //         }

  //         let TechnicalSanctionCopy = document.getElementById("TechnicalSanctionCopy").files;
  //         if (TechnicalSanctionCopy.length === 0) {
  //             alert("Sanction Copy is Missing !!!");
  //             submitLockRef.current = false;
  //             setLoading(false);
  //             return;
  //         }

  //         formData.append("TechnicalSanctionCopy", TechnicalSanctionCopy[0]);

  //         // inside handleSubmit before appending
  //         if (data.isMultipleGp === "Yes") {
  //             formData.append("DPCode", data.DPCode || "");
  //             // formData.append("GPCode", "");
  //         }
  //         if (data.isMultipleGp === "No") {
  //             formData.append("GPCode", data.GPCode || "");
  //             // formData.append("DPCode", "");
  //         }

  //         const result = await sanctionCreation(formData);  // Backend must accept FormData

  //         alert(result);

  //         sessionStorage.removeItem('createTechnicalForm');

  //         setLoading(false);

  //         nav(`/AdminDashboard/GRPendingList`);

  //         // 🚨 IMPORTANT: disable button BEFORE reload
  //         setTimeout(() => {
  //             window.location.reload();
  //         }, 300);
  //     } catch (err) {
  //         console.log(err);
  //         setLoading(false);
  //         submitLockRef.current = false;
  //     } finally {
  //         setLoading(false);
  //         submitLockRef.current = false; // unlock ONLY after response
  //     }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Data of this form ", data);

    // 🔐 HARD LOCK (instant, sync)
    if (submitLockRef.current) return;
    submitLockRef.current = true;

    if (
      !data.HeadCode ||
      !data.sanctionYear ||
      !data.rddUid ||
      !data.proposalUid ||
      !data.District ||
      !data.taluka ||
      !data.constituency ||
      !data.gramPanchayat ||
      !data.workName ||
      !data.workType ||
      !data.sanctionNo ||
      !data.amount ||
      !data.isMultipleGp ||
      !data.Coordinates
    ) {
      submitLockRef.current = false;
      return alert("Data is Missing Fill All Data.. !!!!");
    }

    if (!data.sanctionNo || data.sanctionNo.trim() === "") {
      submitLockRef.current = false;
      return alert("Technical Sanction Number cannot be empty or only spaces");
    }

    if (/^\s|\s$/.test(data.sanctionNo)) {
      submitLockRef.current = false;
      return alert(
        "Technical Sanction Number must not contain leading or ending spaces",
      );
    }

    setLoading(true);

    try {
      const formData = new FormData();

      for (let key in data) {
        if (key === "GPCode" || key === "DPCode") continue;
        formData.append(key, data[key]);
      }

      let TechnicalSanctionCopy = document.getElementById(
        "TechnicalSanctionCopy",
      ).files;
      if (TechnicalSanctionCopy.length === 0) {
        alert("Sanction Copy is Missing !!!");
        submitLockRef.current = false;
        setLoading(false);
        return;
      }

      formData.append("TechnicalSanctionCopy", TechnicalSanctionCopy[0]);

      // inside handleSubmit before appending
      if (data.isMultipleGp === "Yes") {
        formData.append("DPCode", data.DPCode || "");
        // formData.append("GPCode", "");
      }
      if (data.isMultipleGp === "No") {
        formData.append("GPCode", data.GPCode || "");
        // formData.append("DPCode", "");
      }

      const result = await sanctionCreation(formData); // Backend must accept FormData

      if (result.error) {
        alert(result.error);
      } else {
        alert(result);
        nav(`/AdminDashboard/GRPendingList`);
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
      sessionStorage.removeItem("createTechnicalForm");

      setLoading(false);

      // 🚨 IMPORTANT: disable button BEFORE reload
    } catch (err) {
      console.log(err);
      setLoading(false);
      submitLockRef.current = false;
    } finally {
      setLoading(false);
      submitLockRef.current = false; // unlock ONLY after response
    }
  };

  const FetchHeadInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "all");
      console.log("Data i get from Bakcend :: ", res);
      setHeadInfo(res);
    } catch (err) {
      console.log(err);
    }
  };

  const CheckCoordinateFunction = async (id, savedData) => {
    try {
      let res = await GetBudgetHeadInfo(
        id,
        "GetSpecificCoordinatefortechnical",
      );
      if (res.length > 0 && res[0].TechnicalSanctionArea != null) {
        console.log("Data i get form backe--------------------- ", res[0]);
        // setDisableChoosebutton(true);
setData((prev) => ({
  ...prev,
  Area: res[0].TechnicalSanctionArea,
}));        setLocationData(res[0]);
      } else {
        // setDisableChoosebutton(false)
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   const savedFormData = sessionStorage.getItem("createTechnicalForm");
  //   if (savedFormData) {
  //     let savedData = JSON.parse(savedFormData);
  //     setData(savedData);
  //     CheckCoordinateFunction(savedData.workName, savedData);
  //     // sessionStorage.removeItem('createTechnicalForm');
  //   }
  //   GetParticularGR();
  // }, []);
  useEffect(() => {
  const loadTechnicalSanctionData = async () => {
    try {
      const savedFormData =
        sessionStorage.getItem("createTechnicalForm");

      const savedData = savedFormData
        ? JSON.parse(savedFormData)
        : null;

      const res = await getGRNPendingList(
        id,
        "technicalsanction"
      );

      const proj = res[0];

      if (!proj) return;

      // -----------------------------
      // Convert GP into ARRAY
      // -----------------------------
      let defaultGP = [];

      if (Array.isArray(proj.Gram_panchayat)) {
        defaultGP = proj.Gram_panchayat;
      } else if (typeof proj.Gram_panchayat === "string") {
        try {
          const parsed = JSON.parse(proj.Gram_panchayat);

          if (Array.isArray(parsed)) {
            defaultGP = parsed;
          } else if (proj.Gram_panchayat.trim() !== "") {
            defaultGP = [proj.Gram_panchayat];
          }
        } catch (err) {
          if (proj.Gram_panchayat.trim() !== "") {
            defaultGP = [proj.Gram_panchayat];
          }
        }
      }

      // -----------------------------
      // API DATA
      // -----------------------------
      const apiData = {
        HeadCode: proj.HeadCode || "",
        HeadName: proj.HeadName || "",
        HeadCRC: proj.CRC || "",
        sanctionYear: proj.ProposalYear || "",
        rddUid: proj.GRID || "",
        proposalUid: proj.ProposalID || "",
        District: proj.ZillaParishad || "",
        taluka: proj.Taluka || "",
        constituency: proj.Constituency_name || "",

        gramPanchayat: defaultGP,

        workName: proj.Work_name || "",
        GRCopy: proj.GRCopy || "",
        GRDraftCopy: proj.GRDraftCopy || "",
        Area: proj.Area || "",
        amount: proj.ProposalAmount || "",
        workClass: proj.classOfWork || "",
        workType: proj.typeOfWork || "",

        isMultipleGp: proj.isMultipleGP || "",

        JOB_ID: proj.JOB_ID || "",

        // IMPORTANT
        MHUIDNo: proj.MHUIDNo || "",

        Coordinates: proj.Coordinates || "",
        Remark: proj.Remark || "",
        GPCode: proj.GPCode || "",
        DPCode: proj.DPCode || "",
      };

      // -----------------------------
      // SESSION DATA HAS PRIORITY
      // -----------------------------
      const finalData = savedData
        ? {
            ...apiData,
            ...savedData,

            // Always keep GP as array
            gramPanchayat: Array.isArray(savedData.gramPanchayat)
              ? savedData.gramPanchayat
              : apiData.gramPanchayat,

            // Preserve these specifically
            constituency:
              savedData.constituency ?? apiData.constituency,

            MHUIDNo:
              savedData.MHUIDNo ?? apiData.MHUIDNo,

            Area:
              savedData.Area ?? apiData.Area,

            Coordinates:
              savedData.Coordinates ?? apiData.Coordinates,

            Remark:
              savedData.Remark ?? apiData.Remark,
          }
        : apiData;

      // -----------------------------
      // AUTOMATIC MULTIPLE GP
      // -----------------------------
      if (Array.isArray(finalData.gramPanchayat)) {
        if (finalData.gramPanchayat.length === 0) {
          finalData.isMultipleGp = "";
        } else if (finalData.gramPanchayat.length === 1) {
          finalData.isMultipleGp = "No";
        } else {
          finalData.isMultipleGp = "Yes";
        }
      }

      console.log("FINAL TECHNICAL DATA:", finalData);

      setProjectList(proj);
      setData(finalData);

      // -----------------------------
      // CHECK AREA
      // -----------------------------
      if (savedData?.workName) {
        CheckCoordinateFunction(
          savedData.workName,
          finalData
        );
      }

    } catch (err) {
      console.log(
        "Error loading Technical Sanction:",
        err
      );
    }
  };

  loadTechnicalSanctionData();
}, [id]);

  const GetParticularGR = async () => {
    let res = await getGRNPendingList(id, "technicalsanction");
    const proj = res[0];
    console.log("Particular Data i get form backend :: ", res[0]);
    setProjectList(proj);
    setData((prev) => ({
      ...prev,
      HeadCode: proj.HeadCode || "",
      HeadName: proj.HeadName || "",
      HeadCRC: proj.CRC || "",
      sanctionYear: proj.ProposalYear || "",
      rddUid: proj.GRID || "",
      proposalUid: proj.ProposalID || "",
      District: proj.ZillaParishad || "",
      taluka: proj.Taluka || "",
      constituency: proj.Constituency_name || "",
      // gramPanchayat: proj.Gram_panchayat || "",
      gramPanchayat: (() => {
    if (!proj.Gram_panchayat) {
        return [];
    }

    if (Array.isArray(proj.Gram_panchayat)) {
        return proj.Gram_panchayat;
    }

    if (typeof proj.Gram_panchayat === "string") {
        try {
            const parsed = JSON.parse(proj.Gram_panchayat);

            if (Array.isArray(parsed)) {
                return parsed;
            }

            return [proj.Gram_panchayat];
        } catch (err) {
            return [proj.Gram_panchayat];
        }
    }

    return [];
})(),
      workName: proj.Work_name || "",
      GRCopy: proj.GRCopy || "",
      GRDraftCopy: proj.GRDraftCopy || "",
      Area: proj.Area,
      amount: proj.ProposalAmount,
      // GPCode: GPCode,
      getGeometryOfWork: getGeometryOfWork,
      workClass: proj.classOfWork,
      workType: proj.typeOfWork,
      isMultipleGp: proj.isMultipleGP,
      JOB_ID: proj.JOB_ID,
    }));
     setShowPopup(false);
  };

  const resetdata = () => {
    formdataRef.current.reset();
    setData({
      HeadCode: "",
      sanctionYear: "",
      rddUid: "",
      proposalUid: "",
      District: "",
      District: "",
      taluka: "",
      constituency: "",
      gramPanchayat: "",
      village: null,
      workName: "",
      workType: "",
      amount: "",
      sanctionNo: "",
      file: null,
      isMultipleGp: "",
    });
  };

  const getGPCode = async () => {
    try {
      let res1 = await GetBudgetHeadInfo("null", "GetTalukas");
      console.log("res1 :: ", res1);
      let DistrictEng = res1[0].District;

      // If district is Pune-North or Pune-South, use only Pune
      if (DistrictEng && DistrictEng.includes("-")) {
        DistrictEng = DistrictEng.split("-")[0];
      }

      let parsedData = [];

      if (typeof data.gramPanchayat === "string") {
        try {
          parsedData = JSON.parse(data.gramPanchayat);
        } catch (e) {
          console.warn("gramPanchayat not valid JSON:", data.gramPanchayat);
        }
      } else if (Array.isArray(data.gramPanchayat)) {
        parsedData = data.gramPanchayat;
      }

      let firstElement = parsedData.length > 0 ? parsedData[0] : "";

      // let GPName = { gramPanchayat: data.gramPanchayat, DistrictEng: DistrictEng };
      let GPName = { gramPanchayat: firstElement, DistrictEng: DistrictEng };
      let res = await GetGramPanchayatCodes(GPName, "TechnicalSanction");
      console.log("GetGramPanchayatCodes res :: ", res);
      let gp = res.find((item) => item.Village_Panchayat_Name === firstElement);
      if (gp) {
        console.log("Matched GP:", gp);
        setData((prev) => ({
          ...prev,
          GPCode: gp.Village_Panchayat_Code, // ✅ update inside data directly
          DPCode: gp.District_Code,
        }));
        // setDPCode(gp.District_Code)
        // setGPCode(gp.Village_Panchayat_Code)
      } else {
        console.warn("No GP found for", data.gramPanchayat);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //     if (GPCode) {
  //         setData((prev) => ({
  //             ...prev,
  //             GPCode: GPCode,
  //         }));
  //     }
  // }, [GPCode]); // whenever GPCode updates, sync it into data

  useEffect(() => {
    if (data.gramPanchayat) {
      getGPCode();
    }
  }, [data.gramPanchayat]);

  const navigatetoMap = (e) => {
    e.preventDefault();
    if (
      data.HeadCode &&
      data.sanctionYear &&
      data.rddUid &&
      data.proposalUid &&
      data.District &&
      data.taluka &&
      data.constituency &&
      data.gramPanchayat &&
      data.workName &&
      data.workType &&
      data.sanctionNo &&
      data.isMultipleGp
    ) {
      let updatedData = { ...data };
      console.log("data", data);
      // console.log("dpcode", DPCode);
      console.log("gpcode", data.GPCode);

      if (data.isMultipleGp === "Yes") {
        if (!data.DPCode) {
          alert("DP Code not found !!!");
          return;
        }
        console.log("dp");

        updatedData.DPCode = data.DPCode;
        updatedData.GPCode = "";
      } else {
        if (!data.GPCode) {
          alert("GP Code not found !!!");
          return;
        }
        console.log("gp");

        updatedData.GPCode = data.GPCode;
        updatedData.DPCode = "";
      }
      console.log("updateddata", updatedData);
      setData(updatedData);
      console.log("data", data);

      // Save form data to sessionStorage
      sessionStorage.setItem(
        "createTechnicalForm",
        JSON.stringify(updatedData),
      );
      nav(`/AdminDashboard/MapfunctionForTechnicalSanction`);
    } else {
      alert("Fill Above Data !!!!");
    }
  };

  const CancelMapSubmission = () => {
    const shouldclose = window.confirm("Are you Sure ?");
    if (shouldclose) {
      const savedFormData = sessionStorage.getItem("createTechnicalForm");
      if (savedFormData) {
        sessionStorage.removeItem("createTechnicalForm");
      }
      alert("Technical Sanction Cancelled !!");
      nav(`/AdminDashboard/GRPendingList`);
      window.location.reload();
    }
  };

  const GetTypesOfWork = async () => {
    console.log(data.HeadName);
    try {
      let res = await TypesOfWork(data.HeadName);
      setWorkId(res);
      setLoading(true);
      console.log("Type Of Work :: ", res);
      console.log("Work Class :: ", data.workClass);

      if (
        data.HeadName ==
        "3054-2419(Roads and bridge repair maintenance program)"
      ) {
        let workNames = res.filter((item) => item.Work_Type === data.workClass||
    item.Work_Type_marathi === data.workClass);
        console.log("Work Names :: ", workNames);
        setWork(workNames);
      } else {
        let workNames = res.filter((item) => item.Work_Type === data.workClass||
    item.Work_Type_marathi === data.workClass);
        console.log("Work Names :: ", workNames);
        setWork(workNames);
      }
      setLoading(false);
      let GeometryOfWork = res.find((item) => item.Work_name == data.workType);
      console.log("Geometry of Work :: ", GeometryOfWork);
      setGeometryOfWork(GeometryOfWork.Geometry_type);
      setData((prev) => ({
        ...prev,
        getGeometryOfWork: GeometryOfWork.Geometry_type,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.HeadName !== "") {
      GetTypesOfWork();
    }
  }, [data.HeadName, data.workType, data.workClass]);

  // const GetCoordinates = async () => {
  //     try {
  //         console.log(data.sanctionNo);
  //         let res = await GetTechnicalCoordinates(data.sanctionNo);
  //         console.log("Coordinates :: ", res);
  //         let parsedCoords = "";
  //         let gisDataStr = "";
  //         let Remark = "";
  //         let GPCode = "";
  //         let DPCode = "";
  //         if (Array.isArray(res) && res.length > 0) {
  //             gisDataStr = res[0].gis_data;   // string
  //             Remark = res[0].remark || 'NA';
  //             GPCode = res[0].gpcode || 0;
  //             // DPCode = res[0].dpcode || 0;
  //             // try {
  //             //     let coords = JSON.parse(gisDataStr); // parse the string into an array
  //             //     if (Array.isArray(coords) && coords.length > 0) {
  //             //         parsedCoords = `X: ${coords[0].x}, Y: ${coords[0].y}`;
  //             //     }
  //             // } catch (err) {
  //             //     console.error("Error parsing gis_data", err);
  //             const savedFormData = sessionStorage.getItem("createTechnicalForm");
  //             if (savedFormData) {
  //                 const formData = JSON.parse(savedFormData);
  //                 localStorage.getItem("sanctionNo", formData.sanctionNo);
  //                 localStorage.getItem("workType", formData.workType);
  //                 // const sanctionNo = formData.sanctionNo;
  //                 // const workType = formData.workType;
  //                 // setData((prev) => ({
  //                 //     ...prev,
  //                 //     sanctionNo: sanctionNo,
  //                 //     workType: workType,

  //                 // }))
  //             }
  //             // console.log(sanctionNo);
  //             // console.log(workType);
  //             // }
  //             setData((prev) => ({
  //                 ...prev,
  //                 Coordinates: gisDataStr,
  //                 Remark: Remark,
  //                 // GPCode: GPCode || prev.GPCode,
  //                 // DPCode: DPCode || prev.DPCode,
  //             }))
  //         }
  //     }
  //     catch (err) {
  //         console.log(err);
  //     }
  // }

  const GetCoordinates = async () => {
    try {
      console.log(data.sanctionNo);

      let res = await GetTechnicalCoordinates(
        data.sanctionNo,
        data.proposalUid,
      );
      const { status, message, buttonstatus } = res;
      console.log("GIs Data from Backend --> ", res);

      if (status) {
        setactive(true);
        setshowerror(message);
        setsaveButtonDisable(status);
      } else {
        setactive(buttonstatus);
        setsaveButtonDisable(status);
        setshowerror("");
        console.log("Coordinates :: ", res);
        let parsedCoords = "";
        let gisDataStr = "";
        let Remark = "";
        let GPCode = "";
        let DPCode = "";

        if (buttonstatus == false) {
          setData((prev) => ({
            ...prev,
            Coordinates: "",
            Remark: "",
          }));
          setshowerror("");
        } else if (res.message && res.message.length > 0) {
          // setshowerror("Map is assigned to this MHUID Number");
          let GISDATA = res.message[0];
          gisDataStr = GISDATA.gis_data;
          console.log("GisData Str ---> ", gisDataStr);
          Remark = GISDATA.remark || "NA";
          GPCode = GISDATA.gpcode || 0;
          // DPCode = res[0].dpcode || 0;
          // try {
          //     let coords = JSON.parse(gisDataStr); // parse the string into an array
          //     if (Array.isArray(coords) && coords.length > 0) {
          //         parsedCoords = `X: ${coords[0].x}, Y: ${coords[0].y}`;
          //     }
          // } catch (err) {
          //     console.error("Error parsing gis_data", err);
          const savedFormData = sessionStorage.getItem("createTechnicalForm");
          if (savedFormData) {
            const formData = JSON.parse(savedFormData);
            localStorage.getItem("sanctionNo", formData.sanctionNo);
            localStorage.getItem("workType", formData.workType);
            // const sanctionNo = formData.sanctionNo;
            // const workType = formData.workType;
            // setData((prev) => ({
            //     ...prev,
            //     sanctionNo: sanctionNo,
            //     workType: workType,

            // }))
          }
          // console.log(sanctionNo);
          // console.log(workType);
          // }
          setData((prev) => ({
            ...prev,
            Coordinates: gisDataStr,
            Remark: Remark,
            // GPCode: GPCode || prev.GPCode,
            // DPCode: DPCode || prev.DPCode,
          }));
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.sanctionNo) {
      GetCoordinates();
    }
  }, [data.sanctionNo]);

  const checkingGisDatabasedonProposalId = async () => {
    try {
      let res = await GetTechnicalCoordinates(id, "Proposal");
      const { status, message, result } = res;

      if (status) {
        alert(message);
        console.log("Coordinates :: ", res);
        let parsedCoords = "";
        let gisDataStr = "";
        let Remark = "";
        let GPCode = "";
        let DPCode = "";

        let GISDATA = res.result[0];
        gisDataStr = GISDATA.gis_data;
        console.log("GisData Str ---> ", gisDataStr);
        Remark = GISDATA.remark || "NA";
        GPCode = GISDATA.gpcode || 0;
        let techncialsanctionno = GISDATA.activity_code || 0;

        setData((prev) => ({
          ...prev,
          Coordinates: gisDataStr,
          Remark: Remark,
          sanctionNo: techncialsanctionno,
        }));

        setDisableChoosebutton(true);
        // setactive(true);
      }
    } catch (err) {
      alert("Internal Server Error ");
    }
  };

  useEffect(() => {
    if (id) {
      checkingGisDatabasedonProposalId();
    }
  }, [id]);


const apiNames = [...new Set(gramPanchayat.map((gp) => gp.Village_Panchayat_Name))];
const selectedGPs = Array.isArray(data.gramPanchayat) ? data.gramPanchayat : [];
const allGpNames = [...new Set([...selectedGPs, ...apiNames])];

const handleGPChange = (name, checked) => {
  const current = selectedGPs;

  if (checked) {
    if (current.length >= 5) {
      alert("Maximum 5 Gram Panchayats. Uncheck one to select another.");
      return;
    }
    if (current.includes(name)) return;
    const updated = [...current, name];
    setData((prev) => ({
      ...prev,
      gramPanchayat: updated,
      isMultipleGp: updated.length > 1 ? "Yes" : "No",
    }));
  } else {
    const updated = current.filter((gp) => gp !== name);
    setData((prev) => ({
      ...prev,
      gramPanchayat: updated,
      isMultipleGp: updated.length > 1 ? "Yes" : updated.length === 1 ? "No" : "",
    }));
  }
};

const closeGPPopup = () => {
  if (selectedGPs.length === 0) {
    alert("Please select at least 1 Gram Panchayat !");
    return;
  }
  setShowPopup(false);
};

  return (
    <div
      style={{
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
      }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #007bff",
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="justify-content-between d-flex align-items-center px-5 py-4">
          <button className="btn btn-danger rounded-4" onClick={handleBack}>
            {" "}
            <i class="fa fa-arrow-left" aria-hidden="true" /> Back
          </button>
        </div>
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto my-5 budgetElement">
            <div className="row px-3 mb-4 mt-3">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/MIS-Report-Blue-64.png"
                  alt="TechnicalSanction"
                  style={{ width: "32px", height: "32px" }}
                  className="my-auto me-2"
                />
                <h3 className="text-left fw-bold mt-2">Technical Sanction</h3>
              </div>
              <div className="col-12 mt-4">
                <p
                  className="py-2 ps-1 fw-bold text-danger"
                  style={{ backgroundColor: "#FBE7E7" }}
                >
                  Note : Fields marked with * are mandatory
                </p>
              </div>
            </div>
            <form
              onSubmit={handleSubmit}
              ref={formdataRef}
              style={{ padding: "10px", width: "40rem" }}
            >
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>Head Code</label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.HeadCode} disabled />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>Sanction Year *</label>
                  </div>
                  <div className="col-7">
                    <input
                      className="py-2"
                      value={data.sanctionYear}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      GR UID <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.rddUid} disabled />
                  </div>
                </div>
              </div>
              {/* <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-5"><label>Proposal UID <span className='text-danger fw-bold'>*</span></label></div>
                                    <div className="col-7">
                                        <input className='py-2' value={data.proposalUid} disabled />
                                    </div>
                                </div>
                            </div> */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      District <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.District} disabled />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Taluka <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.taluka} disabled />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Constituency Name{" "}
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      className="py-2"
                      name="constituency"
                      value={data.constituency}
                      onChange={HandleChangeData}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Gram Panchayat{" "}
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  {/* <div className="col-7">
                    <input
                      className="py-2"
                      value={data.gramPanchayat}
                      disabled
                    />
                  </div> */}
                    <div className="col-7">
    {
        // (showPopup === false && data.gramPanchayat.length <= 0) &&
        <button
            type="button"
            onClick={() => {
                if (!data.taluka || !data.HeadCode) {
                    alert("Plz Fill Above Missing Data !!");
                } else {
                    setShowPopup(true);
                }
            }}
            className="btn btn-success py-1 px-4"
        >
            Select Gram Panchayat
        </button>
    }

 {Array.isArray(data.gramPanchayat) &&
  data.gramPanchayat.length > 0 && (
    <div
      className="col-12"
      style={{
        overflowX: "hidden",
        overflowWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {data.gramPanchayat.join(", ")}
    </div>
  )}
</div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Work Name <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.workName} disabled />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Job ID <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input className="py-2" value={data.JOB_ID} disabled />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Class Of Work
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      name="workClass"
                      id=""
                      value={data.workClass}
                      onChange={HandleChangeData}
                      disabled
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Type of Work{" "}
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  {/* <div className="col-7">
                    <input
                      name="workType"
                      id=""
                      value={data.workType}
                      onChange={HandleChangeData}
                      disabled
                    ></input>
                  </div> */}
                     <div className="col-7"> <select name="workType" id=""
                                                                value={data.workType}
                                                                onChange={HandleChangeData}
                                                                style={{ fontSize: "18px" }}
                                                                className='py-2'
                                                            >
                                                                <option value="">Choose Type of Work</option>
                                                                {getWork && getWork.map((val, index) => {
                                                                    return (
                                                                        <option key={index} value={val.Work_name}>{val.Work_name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Technical Sanctioned Amount{" "}
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      name="amount"
                      className="w-100 py-2"
                      type="number"
                      value={data.amount}
                      min="0"
                      step="0.01"
                      onChange={HandleChangeData}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                        }
                      }}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      MHUID Number
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      name="sanctionNo"
                      placeholder="Enter MHUID Number"
                      className="py-2"
                      value={data.sanctionNo}
                      onChange={HandleChangeData}
                      maxLength={16}
                      onBlur={(e) => {
                        const value = e.target.value.trim();

                        // Check if at least ONE valid character exists
                        const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
                          value,
                        );
                        if (value && !hasValidChar) {
                          setError("Enter at least one valid character");
                          alert("Enter at least one valid character");
                          setTimeout(() => e.target.focus(), 0);
                        } else {
                          setError("");
                        }
                      }}
                    />
                    {showerror && (
                      <p
                        className="text-danger my-auto fw-bold"
                        style={{ fontSize: "10px" }}
                      >
                        {showerror}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      MHUID Number
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      name="MHUIDNo"
                      placeholder="Enter MHUID Number"
                      className="py-2"
                      value={data.MHUIDNo}
                      onChange={HandleChangeData}
                      maxLength={16}
                      onBlur={(e) => {
                        const value = e.target.value.trim();

                        // Check if at least ONE valid character exists
                        const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
                          value,
                        );
                        if (value && !hasValidChar) {
                          setError("Enter at least one valid character");
                          alert("Enter at least one valid character");
                          setTimeout(() => e.target.focus(), 0);
                        } else {
                          setError("");
                        }
                      }}
                    />
                    {showerror && (
                      <p
                        className="text-danger my-auto fw-bold"
                        style={{ fontSize: "10px" }}
                      >
                        {showerror}
                      </p>
                    )}
                  </div>
                </div>
              </div> */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>This involves multiple Gram Panchayat?</label>
                  </div>
                  <div
                    className="col-7"
                    style={{ justifyContent: "space-evenly", display: "flex" }}
                  >
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="isMultipleGp"
                          value="Yes"
                          checked={data.isMultipleGp === "Yes"}
                        />
                      </label>
                      <label>Yes</label>
                    </div>
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="isMultipleGp"
                          value="No"
                          checked={data.isMultipleGp === "No"}
                        />
                      </label>
                      <label>No</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Choose Area <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    {/* {
                                            diableChoosebutton ? (
                                                <textarea className="form-control" rows={6} readOnly value={locationData?.TechnicalSanctionArea?.map((coord) => `(${coord[0]} , ${coord[1]})`).join('\n') || ''} />
                                            ) : (
                                                <button className='btn btn-success w-100' onClick={(e) => navigatetoMap(e)}>Choose Area</button>
                                            }
                                        ) */}
                    <button
                      className="btn btn-success w-100"
                      onClick={(e) => navigatetoMap(e)}
                      disabled={active}
                    >
                      Choose Area
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>Co-ordinates</label>
                  </div>
                  <div className="col-7">
                    <textarea
                      name="Coordinates"
                      className="py-2"
                      value={data?.Coordinates}
                      onChange={HandleChangeData}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>Remark(If Overlapping)</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      name="Remark"
                      className="py-2"
                      value={data?.Remark}
                      onChange={HandleChangeData}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      Technical Sanction Copy{" "}
                      <span className="text-danger fw-bold">*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="py-2"
                      name="TechnicalSanctionCopy"
                      id="TechnicalSanctionCopy"
                      accept=".pdf,.jpg,.jpeg,.png,image/jpeg,image/png,application/pdf"
                      onChange={handleFileUpload}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-5"></div>
                  <div className="col-7">
                    <div className="col-12">
                      <button
                        type="button"
                        className="px-4 py-1 btn btn-primary"
                        disabled={loading || submitLockRef.current}
                        style={{
                          cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.7 : 1,
                        }}
                        onClick={handleSubmit}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                      <button
                        type="button"
                        className="px-4 py-1 btn btn-danger mx-4"
                        onClick={() => CancelMapSubmission()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div
              style={{
                border: "1px solid #ccc",
                width: "20rem",
                fontFamily: "Arial",
              }}
            >
              <div
                style={{
                  backgroundColor: "#1f6e9b",
                  color: "white",
                  padding: "8px",
                  fontWeight: "bold",
                }}
              >
                Approved Proposal Details
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                      Proposal File Number
                    </td>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                      {project.Proposal_fileNumber}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                      Final Proposal Amount
                    </td>
                    <td
                      style={{ padding: "8px", border: "1px solid #ccc" }}
                    >{`${project.Proposal_amount}`}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                      Proposal Copy
                    </td>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                      {/* <a href={`${apiurl}/ProposalFile/${project.Proposal_copy}`} target='_blank'>{project.Proposal_copy}</a> */}
                      {project.Proposal_copy ? (
                        <p
                          onClick={() =>
                            SecureFileFetching(
                              `ProposalFile/${project.Proposal_copy}`,
                            )
                          }
                          style={{
                            fontSize: "12px",
                            color: "#0d6efd",
                            textDecoration: "underline",
                            cursor: "pointer",
                            margin: 0,
                          }}
                          title={project.Proposal_copy}
                        >
                          {project.Proposal_copy}
                        </p>
                      ) : (
                        <span className="text-danger fw-bold">No File</span>
                      )}
                    </td>
                    <button
                      style={{
                        color: "white",
                        border: "none",
                        padding: "6px 12px",
                        cursor: "pointer",
                      }}
                    ></button>
                  </tr>
                </tbody>
              </table>
            </div>
            {
//                                     showPopup && (
//                                         <div
//                                             style={{
//                                                 position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.21)', backdropFilter: 'blur(4px)', zIndex: 999,
//                                                 display: 'flex', justifyContent: 'center', alignItems: 'center'
//                                             }}
//                                         >
//                                             <div className="m-auto" style={{
//                                                 background: "white",
//                                                 height: '400px',
//                                                 width: "450px",
//                                                 overflowY: "auto",
//                                                 overflowX: "hidden",
//                                                 padding: "20px",       
//                                             }}>
//                         <div
//                           style={{
//                             position: "relative",
//                             textAlign: "center",
//                             marginTop: "20px",
//                             gap: "10px",
//                             display: "flex",
//                             justifyContent: "center",
//                           }}
//                         >
//                       <button
//                         type="button"
//                         // onClick={() => setShowPopup(false)}
//                         onClick={() => {
//                           if (data.isMultipleGp == "Yes") {
//                             if (data.gramPanchayat.length < 2) {
//                               alert("Minimum of 2 Gram Panchayats should be Selected !");
//                               return;
//                             }
//                           }
//                           setShowPopup(false);
//                         }}

//                         style={{
//                           padding: "5px 15px",
//                           fontSize: "13px",
//                           borderRadius: "3px",
//                           border: "none",
//                           backgroundColor: "#2ff01aff",
//                           color: "#fff",
//                           cursor: "pointer",
//                           fontWeight: "500"
//                         }}
//                       >
//                         {t("Save")}
//                       </button>
//                       {/* <button
//                                                         type="button"
//                                                         // onClick={() => setShowPopup(false)}
//                                                         onClick={() => {
//                                                             setData({
//                                                                 ...data,
//                                                                 gramPanchayat: []
//                                                             });
//                                                             setShowPopup(false);
//                                                         }}
//                                                         style={{
//                                                             padding: "5px 10px",
//                                                             fontSize: "18px",
//                                                             borderRadius: "3px",
//                                                             border: "none",
//                                                             backgroundColor: "#af0b0b",
//                                                             color: "#fff",
//                                                             cursor: "pointer",
//                                                             fontWeight: "600", 
//                                                             lineHeight: "1",
//                                                             float: "right"
//                                                         }}
//                                                         title="Close"
//                                                     >
//                                                         {t("Clear Selection")} 
//                                                         &times;
//                                                     </button> */}
//                       <button
//                         type="button"
//                         onClick={() => {
//                           if (data.isMultipleGp === "Yes") {
//                             if (data.gramPanchayat.length < 2) {
//                               alert(
//                                 "Minimum of 2 Gram Panchayats should be Selected !"
//                               );
//                               return;
//                             }
//                           }

//                           setShowPopup(false);
//                         }}
//                         style={{
//                           padding: "5px 15px",
//                           fontSize: "13px",
//                           borderRadius: "3px",
//                           border: "none",
//                           backgroundColor: "#b60101ff",
//                           color: "#fff",
//                           cursor: "pointer",
//                           fontWeight: "500"
//                         }}
//                       >
//                         Close
//                       </button>
//                     </div>

//                                            <div className="col-12">
//     {[...new Set(gramPanchayat.map(gp => gp.Village_Panchayat_Name))].map(
//         (name, index) => (
//             <div
//                 className="col-12"
//                 key={index}
//                 style={{ marginBottom: "5px", fontSize: "12px" }}
//             >
//                 <div className="row">
//                     <div className="col-2 m-auto">
//                         <input
//                             type="checkbox"
//                             id={`gp-${index}`}
//                             value={name}
//                             checked={data.gramPanchayat.includes(name)}
//                             style={{
//                                 margin: "auto"
//                             }}
//                             // onChange={(e) => {
//                             //     if (data.isMultipleGp === "No") {
//                             //         setData(prev => ({
//                             //             ...prev,
//                             //             gramPanchayat: [name]
//                             //         }));

//                             //         setShowPopup(false);
//                             //     } else {
//                             //         if (e.target.checked) {

//                             //             if (data.gramPanchayat.length >= 5) {
//                             //                 alert(
//                             //                     "You can select a maximum of 5 Gram Panchayats only."
//                             //                 );
//                             //                 return;
//                             //             }

//                             //             setData(prev => ({
//                             //                 ...prev,
//                             //                 gramPanchayat: [
//                             //                     ...prev.gramPanchayat,
//                             //                     name
//                             //                 ]
//                             //             }));

//                             //         } else {

//                             //             setData(prev => ({
//                             //                 ...prev,
//                             //                 gramPanchayat:
//                             //                     prev.gramPanchayat.filter(
//                             //                         gp => gp !== name
//                             //                     )
//                             //             }));

//                             //         }
//                             //     }
//                             // }}
//                             onChange={(e) => {
//   if (e.target.checked) {
//     if (data.gramPanchayat.length >= 5) {
//       alert("You can select a maximum of 5 Gram Panchayats only.");
//       return;
//     }

//     setData((prev) => {
//       const updatedGPs = [
//         ...(Array.isArray(prev.gramPanchayat)
//           ? prev.gramPanchayat
//           : []),
//         name,
//       ];

//       return {
//         ...prev,
//         gramPanchayat: updatedGPs,
//         isMultipleGp:
//           updatedGPs.length > 1 ? "Yes" : "No",
//       };
//     });

//     if (data.isMultipleGp === "No") {
//       setShowPopup(false);
//     }
//   } else {
//     setData((prev) => {
//       const updatedGPs = prev.gramPanchayat.filter(
//         (gp) => gp !== name
//       );

//       return {
//         ...prev,
//         gramPanchayat: updatedGPs,
//         isMultipleGp:
//           updatedGPs.length > 1
//             ? "Yes"
//             : updatedGPs.length === 1
//             ? "No"
//             : "",
//       };
//     });
//   }
// }}
//                         />
//                     </div>

//                     <div className="col-10 m-auto">
//                         <label
//                             className="col-12 my-auto"
//                             htmlFor={`gp-${index}`}
//                         >
//                             {name}
//                         </label>
//                     </div>
//                 </div>
//             </div>
//         )
//     )}

//     {/* Close Button */}
//     <div
//         style={{
//             textAlign: "center",
//             marginTop: "20px"
//         }}
//     >
//         <button
//             type="button"
//             onClick={() => {
//                 if (data.isMultipleGp === "Yes") {
//                     if (data.gramPanchayat.length < 2) {
//                         alert(
//                             "Minimum of 2 Gram Panchayats should be Selected !"
//                         );
//                         return;
//                     }
//                 }

//                 setShowPopup(false);
//             }}
//             style={{
//                 padding: "5px 15px",
//                 fontSize: "13px",
//                 borderRadius: "3px",
//                 border: "none",
//                 backgroundColor: "#b60101ff",
//                 color: "#fff",
//                 cursor: "pointer",
//                 fontWeight: "500"
//             }}
//         >
//             Close
//         </button>
//     </div>
// </div>

//                                             </div>
//                                         </div>
//                                     )
//                                 }

showPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.21)",
      backdropFilter: "blur(4px)",
      zIndex: 999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      className="m-auto"
      style={{
        background: "white",
        height: "400px",
        width: "450px",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "20px",
      }}
    >
      {/* Header buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginBottom: "10px",
        }}
      >
        <button
          type="button"
          onClick={closeGPPopup}
          style={{
            padding: "5px 15px",
            fontSize: "13px",
            borderRadius: "3px",
            border: "none",
            backgroundColor: "#2ff01a",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {t("Save")}
        </button>

        <button
          type="button"
          onClick={() =>
            setData((prev) => ({ ...prev, gramPanchayat: [], isMultipleGp: "" }))
          }
          style={{
            padding: "5px 15px",
            fontSize: "13px",
            borderRadius: "3px",
            border: "none",
            backgroundColor: "#6c757d",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Clear All
        </button>

        <button
          type="button"
          onClick={closeGPPopup}
          style={{
            padding: "5px 15px",
            fontSize: "13px",
            borderRadius: "3px",
            border: "none",
            backgroundColor: "#b60101",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Close
        </button>
      </div>

      {/* Count */}
      <div style={{ fontSize: "12px", marginBottom: "8px", fontWeight: "bold" }}>
        Selected: {selectedGPs.length} / 5
      </div>

      {/* GP list */}
      <div className="col-12">
        {allGpNames.map((name) => (
          <div
            className="col-12"
            key={name}
            style={{ marginBottom: "5px", fontSize: "12px" }}
          >
            <div className="row">
              <div className="col-2 m-auto">
                <input
                  type="checkbox"
                  id={`gp-${name}`}
                  checked={selectedGPs.includes(name)}
                  style={{ margin: "auto" }}
                  onChange={(e) => handleGPChange(name, e.target.checked)}
                />
              </div>
              <div className="col-10 m-auto">
                <label className="col-12 my-auto" htmlFor={`gp-${name}`}>
                  {name}
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)} 
          </div>
        </div>
        
      </div>
    </div>
  );
};
 
export default TechnicalSanction;

